import React from 'react';
import SrLink from 'client/components/SrLink/SrLink';

const SrActivityBanner = ({
  activityStr,
  leadFirstName,
  leadUserId,
}) => (
  <SrLink
    to={`/agent/lead/${leadUserId}`}
    className='activity-banner'
  >
    <span>
      {activityStr}
      <span className='activity-banner-name'>
        {
          ` ${leadFirstName} `
        }
      </span>
    </span>

  </SrLink>
);

SrActivityBanner.displayName = 'SrActivityBanner';

export default SrActivityBanner;
